import { forwardRef } from 'react';

import { TProps } from './types/TProps';

export const InlineInheritIconButton = forwardRef<HTMLButtonElement, TProps>(
  ({ className, type = 'button', ...props }, ref) => (
    <button ref={ref} type={type} className={['icon-btn-inline', className].filter(Boolean).join(' ')} {...props} />
  ),
);

InlineInheritIconButton.displayName = 'InlineInheritIconButton';
